import {
  GET_SURVEY_RESPONSES,
  DELETE_SURVEY_RESPONSE,
  CLEAR_SURVEY_RESPONSE,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  survey_responses: [],
  pending: false,
};

export default function SurveyResponse (state = initialState, action) {
  switch (action.type) {
    case GET_SURVEY_RESPONSES:
      return {
        ...state,
        survey_responses: action.payload,
        pending: false,
      };

    case DELETE_SURVEY_RESPONSE:
      return {
        ...state,
        payments: state.survey_responses.filter(
          (row) => row.id !== action.payload
        ),
      };

    case CLEAR_SURVEY_RESPONSE:
      return {
        ...state,
        survey_responses: [],
        pending: false,
      };
    case CLEAR_ALL:
      return {
        ...state,
        survey_responses: [],
        pending: false,
      };
    default:
      return state;
  }
}
